export class PaymentSessionModel {
    public sessionId: string;
    public sessionData: string;
    public vendorTxCode: string;
}